/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getSubmission = /* GraphQL */ `
  query GetSubmission($id: ID!) {
    getSubmission(id: $id) {
      id
      participantId
      formType
      createdAt
      demographics
      raw
      metrics
      year
      month
      updatedAt
      __typename
    }
  }
`;
export const listSubmissions = /* GraphQL */ `
  query ListSubmissions(
    $filter: ModelSubmissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubmissions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        participantId
        formType
        createdAt
        demographics
        raw
        metrics
        year
        month
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
